module.exports = __webpack_public_path__ + "img/web-advertisement.9f018387.png";